import React from 'react';
import { equals, includes, isNotNil, toLower, find, propOr, propEq, any } from 'ramda';
import { isNilOrEmpty } from 'ramda-adjunct';
import { ROLES } from '../lib/rights';
import { RoleValueEnum } from '../components/users/utils/roles';

const useEmailAlreadyUsed = ({
  email,
  users,
  connectedUserEmail,
  defaultTeamId,
  isAdministration,
  isEditMode
}) => {
  if (isNilOrEmpty(users)) return {
    emailAlreadyUsed: false, userExistIsSuperAdmin: false, isConnectedUserSelected: false, userIsTeamMember: false
  };
  const emailLower = toLower(email);
  const existingUser = find(({ email: currentEmail }) => equals(toLower(currentEmail), emailLower), users);
  const isPendingUser = propEq(RoleValueEnum.PENDING, 'status', existingUser);
  const userExistIsSuperAdmin = isNotNil(existingUser) && includes(ROLES.superAdmin, propOr([], 'roles', existingUser));
  const userIsTeamMember = isEditMode || any(propEq(defaultTeamId, 'teamId'), propOr([], 'teamRoles', existingUser));
  const canInviteExistingUser = !!existingUser && !userExistIsSuperAdmin && !userIsTeamMember;
  const emailAlreadyUsed = !!existingUser;
  const displayUpdateUserMsg = isAdministration ? emailAlreadyUsed : emailAlreadyUsed && !canInviteExistingUser;
  return {
    emailAlreadyUsed,
    isConnectedUserSelected: propEq(connectedUserEmail, 'email', existingUser),
    userExistIsSuperAdmin,
    userIsTeamMember,
    canInviteExistingUser,
    existingUser,
    displayUpdateUserMsg,
    isPendingUser
  };
};

export default useEmailAlreadyUsed;